import { Select, SelectProps } from '@mantine/core';

const GENDER_OPTIONS = [
	{ value: 'Male', label: 'Male' },
	{ value: 'Female', label: 'Female' },
	{ value: 'other', label: 'Other' },
];

export const GenderInput = (props: SelectProps) => {
	return <Select data={GENDER_OPTIONS} {...props} />;
};
